"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils_1 = require("./utils");
function validatorCaixa(bankBranch, bankAccount, accountType) {
  var _ref = (0, utils_1.cleanAccountAndBranchStrings)(bankAccount, bankBranch),
    formattedAccount = _ref.formattedAccount,
    formattedBranch = _ref.formattedBranch;
  var _ref2 = (0, utils_1.getAccountAndDigit)(formattedAccount),
    account = _ref2.account,
    accountDigitStr = _ref2.accountDigit;
  var accountDigit = Number(accountDigitStr);
  var multipliers = ['8', '7', '6', '5', '4', '3', '2', '9', '8', '7', '6', '5', '4', '3', '2'];
  var paddedBrach = (0, utils_1.leftPad)(formattedBranch, '0', 4);
  var paddedAccount = (0, utils_1.leftPad)(account, '0', 8);
  var paddedAccountType = (0, utils_1.leftPad)(accountType, '0', 3);
  var accountCode = paddedBrach + paddedAccountType + paddedAccount;
  var result = (0, utils_1.getMultipliersAndAccountProduct)(multipliers, accountCode);
  var divRest = result * 10 % 11;
  if (divRest === 10) {
    return accountDigit === 0;
  }
  return divRest === accountDigit;
}
exports.default = validatorCaixa;